import { createNamespacedHelpers } from "vuex";
const fileModule = createNamespacedHelpers("file");

const OssClient = {
  // install方法是必需的
  // 包含两个参数：Vue 构造器，一个可选的选项对象

  install(Vue) {
    // 使用minxin将功能注入所有组件
    Vue.mixin({
      // 添加到mixin中的任何内容将被注入到所有组件中。
      computed: {
        // 使用对象展开运算符将 getter 混入 computed 对象中
        ...fileModule.mapGetters(["ossClient", "ossClientTime"])
      },
      methods: {
        ...fileModule.mapActions(["initOssClient"]),
        async loadOssClient() {
          if (this.ossClient) {
            let timestamp = new Date().getTime();
            if (timestamp - this.ossClientTime > 30 * 60 * 1000) {
              await this.initOssClient();
            }
          } else {
            await this.initOssClient();
          }
          return Promise.resolve();
        },
        // 上传oss
        async multipartUpload(name, file, options) {
          let that = this;
          await this.loadOssClient();
          return new Promise((resolve, reject) => {
            that.ossClient
              .multipartUpload(name, file, options)
              .then(results => {
                resolve(results);
              })
              .catch(err => {
                reject(err);
              });
          });
        },
        // 获取oss地址
        async signatureUrl(name, options) {
          await this.loadOssClient();
          let res = this.ossClient.signatureUrl(name, options);
          return Promise.resolve(res);
        }
      }
    });
  }
};

export default OssClient;
